import { createReducer } from "@reduxjs/toolkit";
import {
  GET_ORDERS,
  ORDERS_ERROR,
  ORDERS_EXPORT_LOADING,
  ORDERS_EXPORT_SUCCESS,
  ORDERS_LOADING,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  exportLoading: false,
  data: [],
  thisPage: 0,
  nextPage: 0,
  hasMore: true,
  count: 0,
  userId: undefined,
};

const orderReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(ORDERS_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(ORDERS_EXPORT_LOADING, (state) => {
      state.exportLoading = true;
    })
    .addCase(ORDERS_EXPORT_SUCCESS, (state) => {
      state.exportLoading = false;
    })
    .addCase(ORDERS_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
      state.exportLoading = false;
    })
    .addCase(GET_ORDERS, (state, { payload }) => {
      state.data = payload?.orders;
      state.thisPage = payload.thisPage;
      state.nextPage = payload.nextPage;
      state.hasMore = payload.hasMore;
      state.count = payload.count;
      state.loading = false;
    });
});

export default orderReducer;
